export default {
    name: '',
    max_duration: '',
    environment_config_id: '',
    main_area_name: '',
    main_area_lon: '',
    main_area_lat: '',
    areas: [
        {
            name: '',
            type: '',
            polygon: [{ lat: '', lon: '' }],
        },
    ],
    payload_assets: [
        {
            name: '',
            type: '',
            model: '',
            position: { lat: '', lon: '', alt: '' },
            actions_orient: [],
            actions_look: [],
            actions_zoom: [],
            actions_get_detection: [],
        },
    ],
    platform_assets: [
        {
            name: '',
            type: '',
            model: '',
            position: { lat: '', lon: '', alt: '' },
            actions_goto: [],
            actions_neutralization: [],
            actions_get_telemetry: [],
            sparq_id: '',
            payload: [],
        },
    ],
    threats: [
        {
            name: '',
            type: '',
            model: '',
            initial_position: { lat: '', lon: '', alt: '' },
            waypoints: [{ lat: '', lon: '', alt: '', vel: '' }],
            actions_goto: [],
            actions_get_telemetry: [],
            sparq_id: '',
        },
    ],
}
